/**
 * The HTTP status of a failed request, or `undefined` when there was no response.
 *
 * `api` is `@codeleap/common`'s `RequestClient`, and it does not reject with the axios error:
 * `onRequestFailure` wraps it in an `APIError`, which carries the status as a flat `status`
 * field and keeps the original under `axiosError`. Reading `error.response.status` — the shape
 * everyone reaches for — therefore always yields `undefined`, which silently turns every
 * status check into "no", including the ones that decide whether a session is usable.
 *
 * All three shapes are accepted so this works whether the caller is handed the wrapper, the
 * axios error it wraps, or a plain object in a test.
 */
export function getErrorStatus(error: unknown): number | undefined {
  const err = error as {
    status?: number
    response?: { status?: number }
    axiosError?: { response?: { status?: number } }
  }

  return err?.status ?? err?.response?.status ?? err?.axiosError?.response?.status
}

export const hasStatus = (error: unknown, statuses: number[]): boolean => statuses.includes(getErrorStatus(error))
